/* eslint-disable */
import { EventBus } from '@/event'
import { mVMixin } from '@/mixins'

const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'
const releaseType1 = BUILDTYPE == 'PROD' ? 'prodv3' : 'betav1'

export const output = {
    state: {
        baseUrl: `https://vdrm.mobiotics.com/${releaseType}/packager/v1`,
        auth: `Bearer ${localStorage.getItem('token')}`
    },
    actions: {
        getJobById(context, jobId) {
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobs/${jobId}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    })
                    .then((response) => response.json()).then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.data) {
                            resolve(response)
                        } else {
                            resolve(response)
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        getJobDetail(context, jobId) {
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobdetail/${jobId}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    })
                    .then((response) => response.json()).then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.data) {
                            resolve(response)
                        } else {
                            resolve(response)
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },        
        getJobList(context, data) {
            EventBus.$emit('Loader', true)
            let params = `${mVMixin.methods.getParam(data)}`
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobs?${params}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },

        deleteProcessed(context, data) {
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise((resolve, reject) => {
                fetch(`${context.state.baseUrl}/jobs/${data.jobid}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,

                    },
                    method: 'DELETE',
                    body: JSON.stringify(data.packagelist)

                }).then(response => {
                    EventBus.$emit('Loader', false)
                    if (response.ok) {
                        resolve(response.json())
                    } else {
                        resolve(response.json())
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },


        reInitiatePackaging(context, data) {
            EventBus.$emit('Loader', true)
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobs/${data.jobid}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        method: 'PUT',
                        body: JSON.stringify(data.content)
                    })
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/output.js